import { safeboxClient } from 'myNet'

const ROUTE = '/v1/resource-templates'

interface ApiResponse<T = any> {
  code: number
  message: string
  data?: T
}

interface ErrorWithCode extends Error {
  code: number
}

const ResourceTemplateService = {
  getAll: async (request?: any): Promise<ApiResponse> => {
    const response = await safeboxClient.get(`${ROUTE}`, request)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
  get: async (id: string): Promise<ApiResponse> => {
    const response = await safeboxClient.get(`${ROUTE}/${id}`)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
}

export default ResourceTemplateService
